import {State} from '@store/reducers';
import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Store, select} from '@ngrx/store';
import * as fromRoot from '@store/reducers';
import {GetPrivacyPolicyContent} from '@store/actions/auth.actions';

@Component({
  selector: 'idp2-privacy-policy-modal',
  templateUrl: './privacy-policy-modal.component.html',
  styleUrls: ['./privacy-policy-modal.component.scss']
})
export class PrivacyPolicyModalComponent implements OnInit {
  privacyPolicyContent$ = this.store.pipe(
    select(fromRoot.getPrivacyPolicyContent)
  );

  constructor(
    private activeModal: NgbActiveModal,
    private store: Store<State>
  ) {}

  ngOnInit() {
    this.store.dispatch(new GetPrivacyPolicyContent());
  }

  close(): void {
    this.activeModal.close();
  }
}
